import React from "react";

const FormInput = ({
  type = "text",
  error,
  touched,
  style = {},
  className = "",
  ...props
}) => {
  const hasError = error && touched;
  const inputStyle = {
    minHeight: "40px",
    borderRadius: "var(--border-radius, 10px)",
    border: `1px solid var(--border-color, #dee2e6)`,
    fontSize: "14px",
    fontFamily: "var(--font-family, 'Segoe UI', sans-serif)",
    padding: "0.5rem 0.75rem",
    width: "100%",
    ...style,
  };

  if (hasError) {
    inputStyle.borderColor = "var(--states-alert, #dc3545)";
    inputStyle.outline = "none";
  }

  return (
    <>
      <input type={type} className={className} style={inputStyle} {...props} />
      {hasError && (
        <div className="invalid-feedback d-block" style={{ fontSize: "12px", color: "var(--states-alert)" }}>
          {error}
        </div>
      )}
    </>
  );
};

export default FormInput;